import React from 'react';
import Hero from '../components/Hero';
import Mission from '../components/Mission';
import Projects from '../components/Projects';
import AnnualNumbers from '../components/AnnualNumbers';
import Team from '../components/Team';
import Volunteer from '../components/Volunteer';
import Donate from '../components/Donate';

const Home = () => {
  return (
    <main>
      <Hero />
      <Mission />
      <Projects />
      <AnnualNumbers />
      <Team />
      <Volunteer />
      <Donate />
    </main>
  );
};

export default Home; 